import React, { useEffect, useState } from "react";
import styles from './paymentDaysModal.module.scss';
import clsx from "clsx";
import { Button } from "@mui/material";
import IOSSwitch from "Containers/Common/CustomSwitch";
import SelectorMenu from "Containers/Common/CustomSelector/SelectorMenu";
import { useTranslation } from 'react-i18next';

const WorkerPaymentDaysModal = ()=>{
    const { t } = useTranslation();
    const [ selectedAll, setSelectedAll ] = useState(true);
    const [ selectedDays, setSelectedDays ] = useState([]);

    const days = [{
        name: t('workers.workerPaymentDaysModal.days.sunday'),
        value: 0,
    },
    {
        name: t('workers.workerPaymentDaysModal.days.monday'),
        value: 1,
    }, 
    {
        name: t('workers.workerPaymentDaysModal.days.tuesday'),
        value: 2,
    }, 
    {
        name: t('workers.workerPaymentDaysModal.days.wednesday'),
        value: 3,
    }, 
    {
        name: t('workers.workerPaymentDaysModal.days.thursday'),
        value: 4,
    }, 
    {
        name: t('workers.workerPaymentDaysModal.days.friday'),
        value: 5,
    }, 
    {
        name: t('workers.workerPaymentDaysModal.days.saturday'),
        value: 6,
    }];

    useEffect(()=>{
        setSelectedDays([]);
    }, [selectedAll])

    return (<>
        <div className={styles.payments_modal_wrapper}>
            <div className={styles.body}>
                <p className={styles.title_container}>
                    {t('workers.workerPaymentDaysModal.title')}
                </p>
                <div className={styles.switcher_container}>
                    {t('workers.workerPaymentDaysModal.all')}
                    <IOSSwitch checked={selectedAll} onChange={()=>setSelectedAll(!selectedAll)} defaultChecked/>
                </div>
                {!selectedAll && <div className={styles.days_container}>
                    <SelectorMenu
                    isMultiple={true}
                    fullHeight={true}
                    setIsDropdownOpen={() => {}}
                    options={days}
                    setValue={setSelectedDays}
                    value={selectedDays}
                    />
                </div>}

            </div>
            <div className={clsx(styles.actions_container, styles.footer)}>
                <Button className={styles.confirm_button} variant='contained' onClick={()=>console.log('salva')}>
                {t('common.actions.save')}
                </Button>
            </div>
        </div> 
    </>);

}

export default WorkerPaymentDaysModal;